import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { setActiveSection } from "../../reducers/navigationSelection";
import { sectionRoutePaths } from "./navigationData";

export const useSectionFromRoute = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    const matched = Object.entries(sectionRoutePaths).find(([, paths]) =>
      paths.some((p) => pathname === p || pathname.startsWith(p + "/")),
    );
    dispatch(setActiveSection(matched ? matched[0] : null));
  }, [dispatch, pathname]);
};
